import * as React from "react";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { safe } from "../utils";
import { IState, IPageProperties } from "../models";
import { PageCharacteristics } from "../components/PageCharacteristics";
import { getShareClassAndFund } from "../actions";

@connect(mapStateToProps, mapDispatchToProps)
export class PageCharacteristicsContainer extends React.Component<React.Props<{}> & IPageProperties, {}>{
	componentWillMount() {
		this.props.getShareClassAndFund({}, this.props.appParams);
	}
	render() {
		let { shareClass } = this.props;
		if (!shareClass && safe(() => Object.keys(shareClass).length === 0, true)) {
			return null;
		}

		return (
			<PageCharacteristics {...this.props}></PageCharacteristics>
		);
	}
}

function mapStateToProps(state: IState, ownProps: any): IPageProperties {
	return {
		isLoading: state.loading.isLoading,
		fund: state.fund,
		shareClass: state.shareClass
	};
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IPageProperties {
	return {
		getShareClassAndFund: bindActionCreators(getShareClassAndFund, dispatch)
	};
}


// WEBPACK FOOTER //
// ./src/client/containers/PageCharacteristicsContainer.tsx